// extracted by mini-css-extract-plugin
export default {"container":"zD-z","dimension":"AD-z","dimensionLabels":"BD-z"};